module.exports = __webpack_public_path__ + "static/media/GL.18a26e9d.svg";